import { computed, effect, Injectable, signal } from "@angular/core";
import { DataService } from "./data.service";
import { LocalStorageService } from "./localstorage.service";
import { IAuthInfo } from "../types/IAuthInfo";
import { UserService } from "./user.service";
import { HttpErrorResponse } from "@angular/common/http";
import { AppSettings } from "./app.settings";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { AccountInfo, EventType, InteractionStatus } from "@azure/msal-browser";
import { Router } from "@angular/router";
import { filter } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	public authInfo = signal<IAuthInfo | null>(null);
	public msalAccount = signal<AccountInfo | null>(null);
	public authInfoInitialized = signal(false);
	public isAuthenticated = computed<boolean>(() => this.authInfo() !== null)

	constructor(private appSettings: AppSettings,
		private userService: UserService,
		private msalService: MsalService,
		private router: Router
	) {
	}

	initAuthentication(): Promise<void> {
		return new Promise<void>((resolve) => {
			this.msalService.initialize().subscribe(() => {
				this.msalService.instance.addEventCallback((message) => {
					if (message.eventType === EventType.LOGIN_START) {
						console.log('Login Start');
					} else if (message.eventType === EventType.LOGIN_SUCCESS) {
						console.log('Login Success');
					} else if (message.eventType === EventType.LOGIN_FAILURE) {
						console.log('Login failed');
					} else if (message.eventType === EventType.LOGOUT_SUCCESS) {
						console.log('Logout Success');
					} else if (message.eventType === EventType.HANDLE_REDIRECT_START) {
						console.log('HANDLE_REDIRECT_START');
					} else if (message.eventType === EventType.HANDLE_REDIRECT_END) {
						console.log('HANDLE_REDIRECT_END');
					}
				})
				this.msalService.instance.handleRedirectPromise().then((response) => {
					if (response != null && response.account != null) {
						this.msalService.instance.setActiveAccount(response.account);
						this.msalAccount.set(response.account);
						console.log('HandleRedirectPromise');
						this.setAuthInfo().then(() => {
							resolve();
						});
					}
				});
				if (this.msalService.instance.getAllAccounts().length > 0) {
					this.msalAccount.set(this.msalService.instance.getAllAccounts()[0]);
					this.msalService.instance.setActiveAccount(this.msalAccount());
					this.setAuthInfo().then(() => {
						resolve();
					});
				} else {
					this.loginMsal();
				}
			})
		});
	}

	clearAuthentification() {
		// remove authinfo
		this.authInfo.set(null);
		// remove userinfo
		this.userService.clearUserInfo();
	}

	loginMsal() {
		if (this.msalService.instance.getAllAccounts().length == 0) {
			// Aktuelle URL speichern, damit wir nach Redirect dorthin zurückkehren können
			console.log('No accounts found, starting login redirect');
			this.msalService.loginRedirect().subscribe(() => {
				console.log('Login redirect');
			});
		}
	}

	setAuthInfo(): Promise<void> {
		//new Promise<void>((resolve) =>{
		return this.msalService.instance.acquireTokenSilent({
			scopes: [`api://${this.msalService.instance.getConfiguration().auth.clientId}/access`],
			account: this.msalAccount()!
		}).then(tokenResponse => {
			var authInfo: IAuthInfo = {
				userName: this.msalAccount()!.username,
				accessToken: tokenResponse.accessToken
			};
			if (this.authInfo() === null) {
				this.authInfo.set(authInfo);
			} else {
				const info = this.authInfo();
				info!.accessToken = authInfo.accessToken;
			}
			console.log('Authinfo and Bearer token set');
		})
	}
}